import template from './group-list.html';
import controller from './group-list.controller';

let groupListComponent = {
  bindings: {},
  template,
  controller
};

export default groupListComponent;



// WEBPACK FOOTER //
// ./client/app/components/group/group-list.component.js